import type { FilterParams } from "epsm-api-types";

export const getDeduplicatedFilters = (filters?: FilterParams) => {
	if (!filters?.length) return;

	const uniqueFilter = new Set<string>();

	return filters.filter((f) => {
		if ("name" in f && "condition" in f) {
			const key = JSON.stringify([f.name, f.condition]);
			if (!uniqueFilter.has(key)) {
				uniqueFilter.add(key);
				return true;
			}
			return false;
		}

		return true;
	});
};
